import API from "../../api/api";
import Auth from "../../auth";
import { Link } from "react-router-dom";
import React, { Component } from "react";
import Testimonials from "./Testimonials";
import "../../styles/css/Landing/landing.css";
import { Header, Footer } from "../../components";
import { Container, Row, Col } from "bootstrap-4-react";
import ProjectCard from "../../components/ProjectCards/ProjectCard";

class Landing extends Component {
  constructor(props) {
    super(props);
    this.state = {
      jobData: [],
      cardData: [],
    };
  }

  componentDidMount() {
    localStorage.removeItem("token");
    API.get("dashboard/guest")
      .then((res) => {
        this.setState({
          jobData: res.data.response.jobs,
          cardData: res.data.response.card,
        });
      })
      .catch((err) => {
        console.log("AXIOS ERROR: ", err);
      });
  }

  render() {
    const { jobData } = this.state;

    return (
      <div>
        <Header />
        <div className="landingRoot">
          <div className="landingMainHead desktopDiv">
            <div className="landingMain">
              <div className="landingMainLeft">
                <div className="landingMainActives">
                  <p className="landingMainActivesTitle">
                    Are you a Surveyor or a Title company ?
                  </p>{" "}
                  <p className="landingMainActivesSubTitle">
                    Survey Source is the ideal platform for both title companies
                    and surveyors to get connected.{" "}
                  </p>{" "}
                </div>{" "}
                <div className="landingMainBtns">
                  <Link to={Auth.isAuthenticated() ? "/dashboard" : "/signup"}>
                    <button className="bidBtn bidBtn_home">
                      I am a title company{" "}
                    </button>{" "}
                  </Link>{" "}
                  <Link
                    to={
                      Auth.isAuthenticated() ? "/dashboard" : "/signupsurveyor"
                    }
                    className="postJobBtn"
                  >
                    <button className="postBtn postBtn_home">
                      I am a Surveyor{" "}
                    </button>{" "}
                  </Link>{" "}
                </div>{" "}
                <div className="landingStats">
                  <div className="statMain">
                    <div className="statTitle"> Title companies </div>{" "}
                    <div className="statNumber"> 25 </div>{" "}
                  </div>{" "}
                  <div className="howWorksDivider"> </div>{" "}
                  <div className="statMain">
                    <div className="statTitle"> Surveyors </div>{" "}
                    <div className="statNumber"> 285 + </div>{" "}
                  </div>{" "}
                  <div className="howWorksDivider"> </div>{" "}
                  <div className="statMain">
                    <div className="statTitle"> Total jobs </div>{" "}
                    <div className="statNumber"> 440 + </div>{" "}
                  </div>{" "}
                </div>{" "}
              </div>{" "}
            </div>{" "}
          </div>
          <div className="landingMainHeadMobile mobileDiv">
            <div className="landingMainLeftMobile">
              <div className="landingMainActives">
                <p className="landingMainActivesTitleMobile">
                  Are you a surveyor ? or a Title company ?
                </p>{" "}
                <p className="landingMainActivesSubTitleMobile">
                  A common survey platform for both title companies and
                  surveyors.{" "}
                </p>{" "}
              </div>{" "}
              <div className="landingMainBtnsMobile">
                <Link to="/signin">
                  <button className="bidBtnMobile"> Bid job </button>{" "}
                </Link>{" "}
                <Link to="/signin">
                  <button className="postBtnMobile"> Post job </button>{" "}
                </Link>{" "}
              </div>{" "}
              <div className="landingStats">
                <div className="statMain">
                  <div className="statTitleMobile"> Title companies </div>{" "}
                  <div className="statNumberMobile"> 25 </div>{" "}
                </div>{" "}
                <div className="howWorksDivider"> </div>{" "}
                <div className="statMain">
                  <div className="statTitleMobile"> Surveyors </div>{" "}
                  <div className="statNumberMobile"> 285 + </div>{" "}
                </div>{" "}
                <div className="howWorksDivider"> </div>{" "}
                <div className="statMain">
                  <div className="statTitleMobile"> Total jobs </div>{" "}
                  <div className="statNumberMobile"> 440 + </div>{" "}
                </div>{" "}
              </div>{" "}
            </div>{" "}
          </div>
          <Container>
            <Row>
              <Col col="sm-12 md-12 lg-12">
                <div className="section howWorks desktopDiv">
                  <div className="howWorksTitle"> How it works </div>{" "}
                  <div className="howWorksBody">
                    <div className="howWorksHalf">
                      <span> Surveyors </span>{" "}
                      <ol>
                        <li> Bid for posted surveyor jobs </li>{" "}
                        <li> Complete surveyor jobs </li>{" "}
                        <li> Get paid online </li>{" "}
                      </ol>{" "}
                    </div>{" "}
                    <div className="howWorksDivider desktopDiv"> </div>{" "}
                    <div className="howWorksHalf">
                      <span> Title companies </span>{" "}
                      <ol>
                        <li> Post your surveyor job </li>{" "}
                        <li> Receive bids from surveyors </li>{" "}
                        <li> Get the job done </li>{" "}
                      </ol>{" "}
                    </div>{" "}
                  </div>{" "}
                  {/* <div className="howWorksMore">Learn more</div> */}{" "}
                </div>
                <div className="section howWorksMobile mobileDiv">
                  <div className="howWorksTitle"> How it works </div>{" "}
                  <div className="howWorksBodyMobile">
                    <div className="howWorksHalfMobile">
                      <span> Surveyors </span>{" "}
                      <div className="howWorksDividerMobile"> </div>{" "}
                      <ol>
                        <li> Bid for posted surveyor jobs </li>{" "}
                        <li> Complete surveyor jobs </li>{" "}
                        <li> Get paid online </li>{" "}
                      </ol>{" "}
                    </div>{" "}
                    <div className="howWorksHalfMobile">
                      <span> Title companies </span>{" "}
                      <div className="howWorksDividerMobile"> </div>{" "}
                      <ol>
                        <li> Post your surveyor job </li>{" "}
                        <li> Receive bids from surveyors </li>{" "}
                        <li> Get the job done </li>{" "}
                      </ol>{" "}
                    </div>{" "}
                  </div>{" "}
                  <div className="howWorksMore"> Learn more </div>{" "}
                </div>{" "}
              </Col>{" "}
            </Row>{" "}
            <Row>
              <Col col="sm-12 md-12 lg-12">
                <div className="section latestProjects">
                  <div className="latestProjectsTitle">
                    Latest jobs available{" "}
                  </div>{" "}
                  <div className="latestProjectsSubTitle">
                    You can bid on the jobs posted below{" "}
                  </div>{" "}
                  <div className="latestProjectsCards">
                    <div>
                      {" "}
                      {jobData &&
                        jobData.slice(0, 3).map((job) => {
                          return <ProjectCard key={job.id} jobData={job} />;
                        })}{" "}
                    </div>{" "}
                  </div>{" "}
                  <Link to="/browseguest/str">
                    <div className="latestProjectsMore"> Browse more </div>{" "}
                  </Link>{" "}
                </div>{" "}
              </Col>{" "}
            </Row>{" "}
            {/* <Row>
                              <Col col="sm-12 md-12 lg-12">
                                <div className="section testimonials">
                                  <div className="testimonialsTitle">Testimonials</div>
                                  <div className="testimonialsMain">
                                    <Testimonials />
                                  </div>
                                </div>
                              </Col>
                            </Row> */}{" "}
          </Container>{" "}
        </div>{" "}
        <Footer />
      </div>
    );
  }
}

export default Landing;



// WEBPACK FOOTER //
// ./src/pages/Home/Landing.js